import globalData from "./FEU_DATA";

/**
 * The combined result of the default data and global data objects.
 */
export default Object.assign( {
    allowVideoUploads: false,
    videoFeatureAvailable: false,
    i18n: {
        dialogTitle: "Upload Files",
        dialogCancel: "Cancel",
        dialogClose: "Close",
        dialogUpload: "Upload",
        fileAllTooLarge: "The file exceeds the maximum size of %s.",
        fileAllTooLargePlural: "The files exceed the maximum size of %s.",
        fileSomeTooLarge: "A file exceeded the maximum size of %s.",
        fileSomeTooLargePlural: "Some files exceeded the maximum size of %s.",
        fileTooMany: "You can only upload %d file at a time.",
        fileTooManyPlural: "You can only upload %d files at a time.",
        fileTypeNotAllowed: "File type %s is not allowed. Allowed types: %s",
        fileTypeNotAllowedPlural: "Some files have unsupported types. Allowed types: %s",
        fileRemove: "Remove",
        fileName: "File Name",
        fileType: "File Type",
        fileSize: "File Size",
        fileDimensions: "Dimensions",
        fileStatusVideo: "Video upload",
        fileStatusInvalid: "Needs attention",
        fieldName: "Name",
        fieldEmail: "Email",
        fieldCaption: "Caption",
        fieldDescription: "Description",
        fieldAlt: "Alt",
        fieldCustomUrl: "Custom Url",
        fieldCustomTarget: "Custom Target",
        fieldTags: "Tags",
        restUploading: "Uploading, please wait...",
        restBadResponse: "An unexpected response was received from the server.",
        restNetworkError: "An error occurred uploading the files.",
        videoUploadsUnavailable: "Video uploads are not currently available because FooGallery video support is not active on this site.",
        videoPosterFailed: "A preview image could not be generated for this video. Remove it or choose a different MP4 file.",
        videoPosterInvalid: "Video uploads require a generated poster image.",
        resultSucceeded: "Uploaded",
        resultErrored: "Errored",
        resultSkipped: "Skipped",
        resultLocalSkippedSingle: " %d upload skipped.",
        resultLocalSkippedPlural: " %d uploads skipped.",
        requiredFieldsError: "Please fill in all required fields (marked with *).",
        noValidFiles: "No valid uploads are ready to submit."
    },
    rest: {
        endpoint: null,
        nonce: null
    },
    customTargets: [
        { value: "default", label: "Default" },
        { value: "_blank", label: "New Tab (_blank)" },
        { value: "_self", label: "Same Tab (_self)" }
    ]
}, globalData );
